<template>
    <div class="d-lg-flex align-items-center">
        <component :is="headerElement" class="mt-0 mb-2 mb-lg-0">
            <slot />

            <small v-if="showPage" class="text-muted">
                {{ $t('pagination.custom.page', {page: currentPage}) }}
            </small>
        </component>

        <div class="text-right ml-lg-auto">
            <slot name="actions" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageHeader',

    props: {
        isSmall: {type: Boolean},
        meta: {type: Object, default: null},
    },

    computed: {
        headerElement() {
            return this.isSmall ? 'h3' : 'h1';
        },

        pagination() {
            return this.meta || {};
        },

        currentPage() {
            return this.pagination && this.pagination.current_page || 1;
        },

        lastPage() {
            return this.pagination && this.pagination.last_page || 1;
        },

        showPage() {
            return this.lastPage > 1;
        },
    },
};
</script>
